import { GuideStepEnum, GuidePublishState } from '../shared';

// Functions
function getMaxStep(currentMaxStep, nextStep) {
    // Check if assumed max step is greater than the current max step.
    // We don't want the max step to go down.
    if (nextStep > currentMaxStep) {
        return nextStep;
    }
    return currentMaxStep;
}

// Default state
const gameGuideDefaultState = {
    currentStep: GuideStepEnum.START,
    maxStep: GuideStepEnum.START,
    publishState: GuidePublishState.NONE
};

// Reducer
export default function reducer(state = gameGuideDefaultState, action) {
    switch (action.type) {
        case 'GAMEGUIDE_NEXT_STEP': {
            let newStep;

            // Check if login step should be shown
            if (state.currentStep === GuideStepEnum.START && action.payload.userLoggedIn) {
                newStep = GuideStepEnum.checkOOB(state.currentStep + 2);
            } else {
                newStep = GuideStepEnum.checkOOB(state.currentStep + 1);
            }

            // Check OOB and get the maximum step
            const maximumStep = getMaxStep(state.maxStep, newStep);

            // Return new state
            return {
                ...state,
                currentStep: newStep,
                maxStep: maximumStep,
                publishState: GuidePublishState.NONE
            };
        }
        case 'GAMEGUIDE_PREV_STEP': {
            let newStep;

            // Skip login warning step
            if (state.currentStep === GuideStepEnum.SPELER) {
                newStep = state.currentStep - 2;
            } else {
                newStep = GuideStepEnum.checkOOB(state.currentStep - 1);
            }

            // Return new state
            return {
                ...state,
                currentStep: newStep,
                publishState: GuidePublishState.NONE
            };
        }
        case 'GAMEGUIDE_SELECT_STEP': {
            let { payload } = action;
            // Check OOB and get the maximum step
            payload = GuideStepEnum.checkOOB(payload);

            // Clamp the selected step with a max value of the maximum step
            if (payload > state.maxStep) {
                payload = state.maxStep;
            }

            // Return new state
            return {
                ...state,
                currentStep: payload,
                publishState: GuidePublishState.NONE
            };
        }
        case 'FORCE_GAMEGUIDE_SELECT_STEP': {
            let { payload } = action;
            // Check OOB and get the maximum step
            payload = GuideStepEnum.checkOOB(payload);

            // Return new state
            return {
                ...state,
                currentStep: payload,
                maxStep: GuideStepEnum.INFO,
                publishState: GuidePublishState.NONE
            };
        }
        case 'GAMEGUIDE_TOGGLE': {
            // Toggle game guide between 'inactive' and 'level'
            const newStep = state.currentStep === GuideStepEnum.INACTIVE ? GuideStepEnum.LEVEL : GuideStepEnum.INACTIVE;

            // Return new state
            return {
                ...state,
                currentStep: newStep,
                publishState: GuidePublishState.NONE
            };
        }
        case 'GAMEGUIDE_PUBLISH_ERROR': {
            const { payload } = action;
            // Return new state
            return {
                ...state,
                publishState: payload
            };
        }
        default: {
            return state;
        }
    }
}
